import axios from 'axios';

const api = axios.create({
  baseURL: 'https://whatsapp.jipate.com',
  headers: {},
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wa_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  
  return config;
});

export default api;